<script>
import { mapActions } from "vuex";

/**
 * Has no display element, it's only purpose is to load
 * member data within main App when user is ready
 * and has been loaded completely
 */
export default {
  name: "TheMemberLoader",

  mounted() {
    this.fetchMember({
      memberId: this.$auth.user().id,
      setMember: true
    });
  },

  methods: {
    ...mapActions("members", ["fetchMember"])
  },

  render(h) {
    return h();
  }
};
</script>
